import {Component, Input, OnInit, ViewChild} from '@angular/core';
import { Subscription } from 'rxjs';
import { DataService, RenderService, SubscribeService } from 'rs-ng-core';
import { DomSanitizer } from '@angular/platform-browser';
declare const projectCfg;

/**
 * æ¥å£å¯¹è±¡ç±»å
 * indicator: æ¥å£ææ 
 * params: æ¥å£åæ°
 * isFilterParam: æ¯å¦è¿æ»¤æ æåæ°
 * isJoin: æ¯å¦æåæ°æ¼æ¥å¨urlåé¢
 * */
interface InterfaceInfo {
  indicator: string;
  param?: object;
  isFilterParam?: boolean,
  isJoin?: boolean
}

/**
 * æ¨¡ææ¡çåæ°ç±»å
 * content?: string                         // æ¨¡ææ¡åå®¹ï¼åºè¯¥å¯å é¤ï¼
 * data?: object                            // æ¨¡ææ¡æ°æ®
 * formType?: string                        // æ¨¡ææ¡å­è¡¨åç»ä»¶ç±»å
 * isBindModalSubject?: boolean             // æ¯å¦çå¬modalSubjectçæ¨é
 * isFooter?: boolean                       // æ¯å¦æ¾ç¤ºæ¨¡ææ¡åºé¨
 * isVisible?: boolean                      // æ¯å¦æ¾ç¤ºæ¨¡ææ¡
 * name?: string                            // æ¨¡ææ¡åå­ï¼ç¨äºåºåå¤ä¸ªæ¨¡ææ¡
 * title?: string,                          // æ¨¡ææ¡æ é¢
 * type?: string                            // æ¨¡ææ¡çç±»åï¼æè¡¨æ ¼ãå°å¾ãè¡¨åç­ç­ç±»å
 * width?: string,                          // æ¨¡ææ¡å®½åº¦
 * */
interface ModalParam {
  content?: string,
  data?: any,
  formType?: string,
  isBindModalSubject?: boolean,
  isFooter?: boolean,
  isVisible?: boolean,
  name?: string,
  title?: string,
  type?: string,
  width?: string
}

/**
 * å¤é¨ä¼ å¥çæ¨¡ææ¡åæ°
 * isShow?: boolean                    // æ¯å¦æ¾ç¤ºæ¨¡ææ¡
 * formItem: object                    // è¡¨åä¿¡æ¯
 * interfaceInfo?: object              // æ¥å£ä¿¡æ¯
 * compParam?: object                  // æ¨¡ææ¡ç»ä»¶çåæ°
 * */
interface ExtraModalParam {
  compParam?: ModalParam,
  formItem: object,
  interfaceInfo?: InterfaceInfo
}

@Component({
  selector: 'rs-ng-modal',
  templateUrl: './rs-ng-modal.component.html',
  styleUrls: ['./rs-ng-modal.component.scss']
})

export class RsNgModalComponent implements OnInit {

  @ViewChild('formComponent') formComponent;
  @Input() modalParam: ModalParam = {};
  @Input() subCompParam: object;        // æ¨¡ææ¡å­ç»ä»¶çåæ°
  @Input() styleName;
  // @Input() height = '700'
  // @Input() mapParams;            //è¯è®ºæ¨¡å¤ªæ¡å¼¹åºåæ°
  // isVisible = false;
  // modalInfo;                    // å¤é¨ä¼ å¥çæ¨¡ææ¡åæ°
  // column = {xxl: 1, xs: 2, md: 3};
  // commentData;
  formItem: any;                  // è¡¨åé¡¹éç½®
  relationFieldList: object;      // è¡¨åå³èçå­æ®µåè¡¨ï¼è¿éè®¾ç½®ä¸ºobjectç±»åæ¯ä¸ºé²æ­¢æ°æ®å­æ®µä¸è¡¨åé¡¹å­æ®µä¸å¹é
  modalSubscription: Subscription;

  // interfaceCfg = JSON.parse(JSON.stringify(projectCfg['interfaceCfg']));
  // interfaceInfo;
  // downData = [];             // ä¸è½½ææ¡£æ¾ç¤ºå¼
  // treeData;
  // headerList?: Array<string>; // è¡¨å¤´æå­åè¡¨
  // fieldList?: Array<string>;   // è¡¨æ ¼å­æ®µåè¡¨
  // tableData: {       // æ¥æ¶è¡¨æ ¼æ°æ®ä»¥åé¡µç ç­åæ°
  //   dataList: Array<object>,
  //   total: number
  // } = {
  //   dataList: [],
  //   total: 0
  // };
  // image: any;

  constructor(
    private subscribeService: SubscribeService
  ) {
  }

  // ç»å®modalå¼¹çªç¡®å®æé®ç¹å»äºä»¶
  /**
   * @param formType: éå¯¹è¡¨åç»ä»¶çç±»åï¼å¦ææ¯submitåä¼ç¨è¿äºæ°æ®è¯·æ±æäº¤æ¥å£ï¼å¦ææ¯submitåä¼ç¨è¿äºæ°æ®è¯·æ±æäº¤æ¥å£
   * */
  handleOk(formType?): void {
    const modalData = this.modalParam.data;

    if (this.modalParam.type === 'form') {
      if (this.formComponent.validateForm.valid) {
        this.subscribeService.rsNgModalDataSubject.next({
          formItem: this.formItem,
          formType,
          data: this.formComponent.validateForm.value
        });
        this.modalParam.isVisible = false;
      }
    } else {
      if (modalData) {
        this.subscribeService.rsNgModalDataSubject.next({
          formItem: this.formItem,
          data: modalData,
          relationFieldList: this.relationFieldList
        });
      }
      this.modalParam.isVisible = false;
    }
  }

  // ç»å®modalå¼¹çªåæ¶æé®ç¹å»äºä»¶
  handleCancel(): void {
    this.modalParam['isVisible'] = false;
  }

  ngOnInit() {
    this.listen();
    // this.treeNodes = this.modalParam.data;
  }

  ngOnDestroy() {
    this.modalSubscription && this.modalSubscription.unsubscribe();
  }

  // è·åç¾åº¦å°å¾ç»ä»¶è¿åå¼
  getBMapData($event): void {
    this.modalParam.data = $event;
  }

  // è·åè¡¨æ ¼ç»ä»¶è¿åå¼
  getTableData($event) {
    this.modalParam.data = $event;
    if (!this.modalParam['isFooter']) {
      this.handleOk(this.modalParam['formType']);
    }
  }

  // ä¸è½½
  handleDownload(event, data) {
    event.preventDefault();
    const indicator = this.modalParam['interfaceInfo']['indicator'];
    const params = [];
    this.modalParam['interfaceInfo']['params'].map(item => {
      params.push(data[item]);
    });
    const docName = data['docsName'];
    // this.getDataList(indicator, params, docName)
  }

  // getDataList(indicator?, mapParams?, docName?, type?) {
  //   let interfaceParams = indicator ? this.interfaceCfg[indicator] : this.interfaceCfg[this.modalParam.interfaceURL];
  //   const paramList = interfaceParams['params'];
  //   let requestURL = interfaceParams['url'];
  //   let paramObj = {};
  //   if (paramList && indicator !== 'projectManageGetLogo') {
  //     paramList.forEach(param => {
  //       paramObj[param] = this.interfaceInfo['param'][param] || mapParams[0];
  //     });
  //   } else {
  //       paramList.forEach(param => {
  //         paramObj[param] =  mapParams[0];
  //       });
  //   }
  //   if (indicator === 'projectManageDownload') {
  //     requestURL = requestURL + '?' + paramList[0] + '=' + mapParams[0]
  //   }
  //
  //   this.dataService.getStatisticsData(
  //     requestURL,
  //     paramObj,
  //     interfaceParams.type,
  //   ).subscribe(res => {
  //     // if (type === "url") {
  //     //   let data;
  //     //   let reader = new window.FileReader();
  //     //   reader.readAsDataURL(res);
  //     //   reader.onloadend = () => {
  //     //     data = reader.result;
  //     //     this.image =  this.sanitizer.bypassSecurityTrustResourceUrl(data);
  //     //   }
  //     // }
  //     // else  if (docName) {
  //     //   interfaceParams.fileName = docName;
  //     //   let url = window.URL.createObjectURL(res);
  //     //   let link = document.createElement('a');
  //     //   link.style.display = 'none';
  //     //   link.href = url;
  //     //   link.download = interfaceParams.fileName + interfaceParams.fileFormat; // docNumber å¨ææä»¶å
  //     //   document.body.appendChild(link);
  //     //   link.click();
  //     // } else if (type) {
  //     //   const indicatorRenderFn = this.modalParam['interfaceInfo'] ? this.modalParam['interfaceInfo']['renderFn'] : '';
  //     //   const renderFn = indicatorRenderFn
  //     //   this.treeData = renderFn ? this.renderService[renderFn](res) : res;
  //     //
  //     // } else {
  //     //   // è·åæ é¢çå¼
  //     //   if (this.modalParam.ifText) {
  //     //     this.modalParam.textParam.map(item => {
  //     //       this.modalParam['text'] = res[item]
  //     //     })
  //     //   }
  //     //   // æ å½¢ç»ææ°æ®åå
  //     //   if (this.modalParam['interfaceInfo'] && this.modalParam['interfaceInfo']['type'] == 'tree') {
  //     //     const returnParam = this.modalParam['interfaceInfo']['returnParam'];
  //     //     let queryCondition = null;
  //     //
  //     //     if (returnParam) {
  //     //       queryCondition = res[returnParam[0]['field']]
  //     //     }
  //     //     this.subscribeService.treeParamSubject.next({
  //     //       param: {
  //     //         field:returnParam[0]['field'],
  //     //         queryCondition
  //     //       }
  //     //     });
  //     //   }
  //     //   this.commentData = res
  //     //
  //     //   if (this.modalParam.moduleList) {
  //     //     const moduleArr = [];
  //     //     const moduleArrList = [];
  //     //     if (res.moduleList || res.docsList) {
  //     //
  //     //       res.moduleList.forEach(item => {
  //     //         moduleArr.push(item.moduleName);
  //     //       });
  //     //       this.commentData['moduleList'] = moduleArr;
  //     //       if (res.docsList && res.docsList.length) {
  //     //         this.downData = [];
  //     //         res.docsList.map(item => {
  //     //           this.downData.push(item);
  //     //         })
  //     //       } else {
  //     //         this.downData = null;
  //     //       }
  //     //
  //     //     }
  //     //
  //     //     // è·åcgi
  //     //     if (res.cgiList) {
  //     //       let cgi = []
  //     //       // console.log(res)
  //     //       res.cgiList.map(item => {
  //     //         cgi.push(item['cgi'])
  //     //       })
  //     //       this.commentData['cgiList'] = cgi;
  //     //
  //     //     }
  //     //    // åè­¦éç½®warningRuleList
  //     //     if (res.warningRuleList) {
  //     //       const warningRuleList = res.warningRuleList.map(item => {
  //     //         if(item['gradeId']=== 0){
  //     //           item['gradeId']='â çº§çº¢è²åè­¦'
  //     //         }else if(item['gradeId']=== 1){
  //     //           item['gradeId']=' â¡çº§æ©è²åè­¦'
  //     //         }else if(item['gradeId']=== 2){
  //     //           item['gradeId']='â¢çº§é»è²åè­¦'
  //     //         }else{
  //     //           item['gradeId']='â£çº§èè²åè­¦'
  //     //         }
  //     //         return item['gradeId'] + '>=' + item['gradeValue'];
  //     //
  //     //
  //     //       })
  //     //       this.commentData['warningRuleList'] = warningRuleList;
  //     //
  //     //     }
  //     //   }
  //     //
  //     //    // æ¨¡ææ¡æ¯è¡¨æ ¼
  //     //   //  if (this.modalParam.type==='table') {
  //     //
  //     //
  //     //   //   res.list.forEach(item=> {
  //     //   //     if(item.gradeId){
  //     //   //       if(item.gradeId = 0){
  //     //   //         item.gradeId='çº¢è²åè­¦'
  //     //   //        }else if(item.gradeId = '1'){
  //     //   //         item.gradeId='æ©è²åè­¦'
  //     //   //        }else if(item.gradeId = 2){
  //     //   //         item.gradeId='é»è²åè­¦'
  //     //   //        }else if(item.gradeId = 3){
  //     //   //         item.gradeId='èè²åè­¦'
  //     //   //        }
  //     //   //      }
  //     //   //   });
  //     //
  //     //
  //     //   //   this.modalParam.param.dataList=res.list;
  //     //   //   this.modalParam.param.total=res.total;
  //     //   //   // this.tableData.total=res.total;
  //     //   //   console.log(this.modalParam.param);
  //     //
  //     //   //   // this.tableHead.headerList=this.modalParam.params.headerList;
  //     //   //   // this.tableHead.fieldList=this.modalParam.params.fieldList;
  //     //   //   }
  //     //
  //     //   if(res.warningContactList){
  //     //     const contactList=res.warningContactList.map(item=>{
  //     //       return item.contactName+'-'+item.contactTel
  //     //     })
  //     //    const warningContact =contactList.join(';')
  //     //    res['warningContactList'] = warningContact;
  //     //   }
  //     //
  //     //   if(res.warningReceiverList){
  //     //     const receiverList=res.warningReceiverList.map(item=>{
  //     //       return item.receiverName+'-'+item.receiverTel
  //     //     })
  //     //    const warningReceiver =receiverList.join(';')
  //     //    res['warningReceiverList'] = warningReceiver;
  //     //   }
  //     //
  //     //   if(this.modalParam.isWarning){
  //     //     const warningStatus={
  //     //       0: 'æ æ',
  //     //       1: 'ææ',
  //     //     }
  //     //     res['status'] = warningStatus[res['status']];
  //     //     const smsAuto={
  //     //       0: 'ä¸èªå¨ä¸å',
  //     //       1: 'èªå¨ä¸å',
  //     //     }
  //     //     res['ifSmsAuto'] = smsAuto[res['ifSmsAuto']];
  //     //   }
  //     //
  //     //   if(this.modalParam.isMsg){
  //     //     const warningLevel={
  //     //       0: '1çº§',
  //     //       1: '2çº§',
  //     //       2: '3çº§',
  //     //       3: '4çº§',
  //     //     }
  //     //     res['warningGrade'] = warningLevel[res['warningGrade']];
  //     //     const infoStatus={
  //     //       0: 'åéå¤±è´¥',
  //     //       1: 'åéæå',
  //     //     }
  //     //     res['status'] = infoStatus[res['status']];
  //     //   }
  //     //
  //     //   if (this.modalParam.isStatue) {
  //     //     const userStatus = {
  //     //       'ENABLE': 'å¯ç¨',
  //     //       'UNABLE': 'åç¨',
  //     //     };
  //     //     res['status'] = userStatus[res['status']];
  //     //   }
  //     // }
  //   });
  // };

  // çå¬äºä»¶
  listen() {
    // çå¬æ¨¡ææ¡å¤é¨ä¼ å¥åæ°
    if (this.modalParam['isBindModalSubject']) {
      this.modalSubscription = this.subscribeService.modalSubject.subscribe((extraModalParam: ExtraModalParam) => {
        this.formItem = extraModalParam['formItem'];
        const compParam = extraModalParam['compParam'];
        this.modalParam['title']=extraModalParam['modalTitle'] || this.modalParam['title']
        let isCurrentModal = true;                // æ¯å¦å½åæ¨¡ææ¡æ å¿

        extraModalParam['relationFieldList'] && (this.relationFieldList = extraModalParam['relationFieldList']);
        if (compParam) {
          if (compParam['name']) {
            if (compParam['name'] === this.modalParam['name']) {
              Object.assign(this.modalParam, compParam);
            } else {
              isCurrentModal = false;
            }
          } else {
            Object.assign(this.modalParam, compParam);
          }
        }

        if (isCurrentModal && extraModalParam['interfaceInfo'] && this.subCompParam) {
          this.subCompParam['interfaceInfo'] = extraModalParam['interfaceInfo'];
          if (this.modalParam.type === 'table') {
            Object.assign(this.subCompParam['param'], {...this.subCompParam['interfaceInfo']['param']});
          }
        }
      });
    }

    // this.modalSubscription = this.subscribeService.modalSubject.subscribe(modalParam => {
    //   // this.modalInfo = modalParam;
    //   // const param = modalParam['modal'] || modalParam;
    //   // console.log(this.modalInfo);
    //   // console.log(this.modalParam);
    //   // è¯·æ±æ å½¢ç»ææ°æ®æº
    //   if (this.modalParam['interfaceInfo'] && this.modalParam['interfaceInfo']['type'] === 'tree') {
    //     // this.getDataList(this.modalParam['interfaceInfo']['indicator'], '', '', 'tree')
    //   }
    //   setTimeout(() => {
    //     if (param['interfaceInfo']) {
    //       this.interfaceInfo = param['interfaceInfo'];
    //       // this.getDataList(param['interfaceInfo']['indicator']);
    //     }
    //     if (param['isShow']) {
    //       // å¦æåæ°å­å¨æ¨¡ææ¡åå­ï¼åéè¦å¤æ­æ¯å¦ä¸å½åæ¨¡ææ¡åå­å¹éï¼è¥æ¯åæå¼ï¼å¦åå³é­
    //       if (param.name) {
    //         // this.isVisible = param.name === this.modalParam.name;
    //       } else {
    //         // this.isVisible = true;
    //       }
    //     }
    //   }, 100);
    //
    //   // å¦æå­å¨è¯·æ±å¾ççurl
    //   // if (this.modalInfo['interfaceInfo'] && this.modalInfo['interfaceInfo']['imgIndicator']) {
    //   //   const params = [];
    //   //   this.modalParam['imgParams'].map(item => {
    //   //     params.push(this.modalInfo['interfaceInfo']['param'][item]);
    //   //   });
    //   //   this.getDataList(this.modalInfo['interfaceInfo']['imgIndicator'], params, '', 'url')
    //   // }
    // });
  }

}
